module.exports = __webpack_public_path__ + "built-card-top-right@2x.1eC1DW_l.png";